import React, { Suspense, useState, ReactNode, PropsWithChildren } from 'react';
import { PageLoading } from 'components/PageLoading';
import { useLocation, useParams } from 'react-router-dom';
import ChangeOrganization from 'components/_common/panel/ChangeOrganization';
import { border, colors } from 'theme';
import { MenuItemExt } from 'components/_common/PanelMenu';
import { Dialog } from 'components/_new/Dialog';
import Navigation from './Navigation';
import MobileBottomNavigation from './MobileBottomNavigation';

type PanelLayoutProps = PropsWithChildren<{
	header?: ReactNode | (() => ReactNode);
	right?: ReactNode | (() => ReactNode);
	navigationOptions: MenuItemExt[];
	navigationTop?: ReactNode | (() => ReactNode);
	navigationBottom?: ReactNode | (() => ReactNode);
	onNavigationExpandStateChange?: (id: string, expanded: boolean) => void;
}>;

const PanelLayout = (props: PanelLayoutProps) => {
	const {
		header,
		navigationOptions,
		navigationTop,
		navigationBottom,
		right,
		children,
		onNavigationExpandStateChange,
	} = props;

	const location = useLocation();

	const [showOrgDialog, setShowOrgDialog] = useState(false);
	const { organizationName, programName } = useParams();

	const isUserPanel = location.pathname.includes('/panel');

	const renderHeader = (): ReactNode => {
		if (header) {
			if (typeof header === 'function') {
				return header();
			}
			return header;
		}
		return null;
	};

	const renderRight = (): ReactNode => {
		if (right) {
			let content = null;
			if (typeof right === 'function') {
				content = right();
			} else {
				content = right;
			}
			return (
				<div
					id="scrollWrapperRightRef"
					className="hidden xxl-flex p-styled-scrollbar p-styled-scrollbar-purplishblue overflow-y-auto overflow-x-hidden sidecol"
				>
					{content}
				</div>
			);
		}
		return null;
	};

	return (
		<div className="flex flex-1 max-h-screen">
			<Navigation
				navigationOptions={navigationOptions}
				top={navigationTop}
				bottom={navigationBottom}
				onExpandStateChange={onNavigationExpandStateChange}
			/>

			<div className="flex flex-1 flex-column pr-0 sm:pr-3 overflow-x-hidden">
				<div className="flex align-items-center h-5rem py-2" style={{ borderBottom: border(colors.lightGray) }}>
					{renderHeader()}
				</div>

				<div className="flex-1 flex justify-content-between overflow-hidden sm:mb-0">
					<div
						id="scrollWrapperRef"
						className={`relative p-styled-scrollbar p-styled-scrollbar-purplishblue flex-1 px-2 pr-3 py-3 overflow-y-auto ${
							isUserPanel ? 'pb-20' : ''
						} md:pb-3`}
					>
						<div id="scrollWrapperInnerRef" className="hidden-accessible" />
						<Suspense fallback={<PageLoading />}>{children}</Suspense>
					</div>
					{renderRight()}
				</div>

				<Dialog
					title="Zmiana organizacji"
					size="sm"
					onHide={() => setShowOrgDialog(false)}
					visible={showOrgDialog}
				>
					<ChangeOrganization
						defaultSelected={
							organizationName && programName
								? {
										organization: organizationName,
										program: programName,
									}
								: undefined
						}
						card
						onCancel={() => setShowOrgDialog(false)}
					/>
				</Dialog>

				{isUserPanel && <MobileBottomNavigation />}
			</div>
		</div>
	);
};

export default PanelLayout;
